
<template>
  <div class="courseList" :class="{ isIosx: isIosx }">
    <van-sticky>
      <div class="courseListNav">
        <img
          class="navLeft"
          src="./../../assets/school/backh.png"
          @click="prev()"
        />
        <span class="navTitle">课程列表</span>
      </div>
    </van-sticky>
    <div class="courseListtop">
      <img
        src="./../../assets/school/singlerow.png"
        v-if="!showType"
        @click="changeShowType()"
      />
      <img
        src="./../../assets/school/morerow.png"
        v-else
        @click="changeShowType()"
      />
    </div>
    <div class="courseListContent">
      <CourseColum :dataList="dataList" v-if="showType"></CourseColum>
      <CourseRow :dataList="dataList" v-else></CourseRow>
      <div class="btm_tip">
        <p>没有更多了</p>
      </div>
    </div>
  </div>
</template>

<script>
import CourseColum from "./components/courseColumn.vue";
import CourseRow from "./components/courseRow.vue";
export default {
  data() {
    return {
      isIosx: false,
      showType: true,
      isMore: false,
      only_key:'',
      ids: [],
      dataList: [],
      data: {},
    };
  },
  components: { CourseColum, CourseRow },
  mounted() {
    this.isIosx = this.isIphoneX();
    if (JSON.parse(sessionStorage.getItem("token"))) {
      this.$api.setToken(JSON.parse(sessionStorage.getItem("token")));
    }
    if (this.$route.query.only_key) {
      this.only_key = this.$route.query.only_key;
    }
    if (this.$route.query.isMore) {
      this.isMore = JSON.parse(this.$route.query.isMore);
    }
    if (this.$route.query.data) {
      if (this.isMore) {
        this.ids = JSON.parse(this.$route.query.data);
      } else {
        this.data = JSON.parse(this.$route.query.data);
      }
      this.getData();
    }
  },
  methods: {
    prev() {
      this.$router.go(-1);
    },
    changeShowType() {
      this.showType = !this.showType;
    },
    getData() {
      let params;
      if (this.isMore) {
        params = {
          course_ids: this.ids,
          only_key:this.only_key,
        };
      } else {
        params = {
          only_key: this.data.only_key,
          course_ids: this.data.course_ids,
          recommended_type: this.data.recommended_type,
          auto_type: this.data.auto_type,
        };
      }
      this.$api.post("school/member/tab/more/course", params).then((res) => {
        this.dataList = res;
      });
    },
  },
};
</script>

<style scoped>
.courseList {
}
.courseListNav {
  color: #404247;
  height: 22px;
  padding-top: 38px;
  padding-left: 16px;
  padding-right: 16px;
  padding-bottom: 11px;
  background-color: #ffffff;
  position: relative;
}
.courseListNav .navLeft {
  position: absolute;
  left: 16px;
  width: 24px;
  height: 24px;
}
.courseListNav .navTitle {
  font-size: 16px;
  font-weight: bold;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}
/*courseListtop */
.courseListtop {
  height: 40px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin: 0 16px;
}
.courseListtop img {
  width: 16px;
  height: 16px;
}
/* content */
.courseListContent {
  margin: 16px;
  padding-bottom: 40px;
}

.btm_tip {
  display: flex;
  justify-content: center;
}
.btm_tip p {
  font-size: 14px;
  font-weight: 400;
  color: #9ca1ad;
  line-height: 20px;
  text-align: center;
  margin: 32px 0;
}

.isIosx .courseListNav {
  padding-top: 44px;
}
</style>